import { API } from "@swivl-mono/api-helper";
import { warn } from "@swivl-mono/helpers";
import { UserVarKey, UserVarsMap } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";
import { AlertsModel } from "../Notifications/Alerts.Model";

interface StoreInterface {
  vars: { [userId: number]: UserVarsMap };
}
//TODO we may want to remove everything from the user vars so we don't accidently mod user vars directly? Not sure. We want to make sure we never get a merge issue.
const BlankState: StoreInterface = {
  vars: {}
};

export default class UserVarsModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = UserVarsModel.useState.setState;
  static get state() {
    return UserVarsModel.useState.getState();
  }
  static reset() {
    UserVarsModel.setState({ ...BlankState });
  }

  static async loadForUser(userId: number) {
    API.UserVars.getAllVarsForUser(Member.orgId, userId)
      .then((userVars) => {
        const vars = { ...UserVarsModel.state.vars };
        vars[userId] = userVars;
        UserVarsModel.setState({ vars });
      })
      .catch((error) => {
        warn("Error loading user vars", error);
        AlertsModel.errorToast("Error loading user variables");
      });
  }

  static async updateUserVars(userId: number, userVars: Partial<{ [key in UserVarKey]: any }>) {
    try {
      const vars = { ...UserVarsModel.state.vars };
      vars[userId] = { ...vars[userId], ...userVars };

      UserVarsModel.setState({ vars });
    } catch (error) {
      warn("Error saving user var", error);
      AlertsModel.errorToast("Error saving user variable");
    }
  }

  static async saveUserVars(userId: number, userVars: Partial<{ [key in UserVarKey]: any }>) {
    try {
      await API.UserVars.saveUserVars(Member.orgId, userId, userVars);

      const vars = { ...UserVarsModel.state.vars };
      vars[userId] = { ...vars[userId], ...userVars };

      UserVarsModel.setState({ vars });
    } catch (error) {
      warn("Error saving user var", error);
      AlertsModel.errorToast("Error saving user variable");
    }
  }
}
